import '../index.css'

const ApiDoc = (props) => {
  return <iframe src={`${window.location.origin}/${props.apiDocfileName}`} style={{ width: '100%', height: 'calc(100vh - 4px)', border: 0, padding: 0, margin: 0, overflow: 'hidden' }} />
}
export default ApiDoc;